import axios from 'axios'
import AxiosInstance from 'utils/AxiosInstance'
import {
  BASE_URL_API as baseURL,
  ACCESS_TOKEN as accessToken,
  randomString,
} from 'utils/helpers'

import * as types from './constants'
import { Link } from 'react-router-dom'

import { fetchRoles } from '../Role/actions'
import qs from 'qs'
import { clientBaseUrl } from 'utils/AxiosInstance'
import { getStatusColorReport } from 'utils/helpers'
import { getLabelForPublicCatalog } from 'utils/helpers'
import { getFontawesomeIconFromStatus } from 'views/pages/ManagerReport/CellConfig'
const CancelToken = axios.CancelToken
let call1 = CancelToken.source()
let call2 = CancelToken.source()
let call3 = CancelToken.source()
let callForRoles = CancelToken.source()

export const search = (value) => ({ type: types.SET_SEARCH_VALUE, value })
export const setCoursesRows = (rows) => ({ type: types.SET_ROWS, rows })
export const setGroupsRows = (rows) => ({ type: types.SET_GROUPS_ROWS, rows })
export const setExternalReportsRows = (rows) => ({
  type: types.SET_EXTERNAL_REPORTS_ROWS,
  rows,
})

export const setCourseModule = (data) => ({
  type: types.SET_GROUPS_MODULE,
  data,
})
export const setExternalReportsModule = (data) => ({
  type: types.SET_EXTERNAL_REPORTS_MODULE,
  data,
})
export const setGroupsUpdated = (value) => ({
  type: types.SET_GROUPS_UPDATED,
  value,
})
export const setCoursesUpdated = (value) => ({
  type: types.SET_COURSES_UPDATED,
  value,
})
export const setExternalReportsUpdated = (value) => ({
  type: types.SET_EXTERNAL_REPORTS_UPDATED,
  value,
})
export const setGroupsFocusedCell = (value) => ({
  type: types.SET_GROUPS_FOCUSED_CELL,
  value,
})
export const setCoursesFocusedCell = (value) => ({
  type: types.SET_COURSES_FOCUSED_CELL,
  value,
})
export const setExternalReportsFocusedCell = (value) => ({
  type: types.SET_EXTERNAL_REPORTS_FOCUSED_CELL,
  value,
})

export const setCoursesColumnDefs = (columnDefs) => ({
  type: types.SET_COLUMN_DEFS,
  columnDefs,
})
export const setExternalReportsColumnDefs = (columnDefs) => ({
  type: types.SET_EXTERNAL_REPORTS_COLUMN_DEFS,
  columnDefs,
})
export const onChangeNewFilterName = (value) => ({
  type: types.SET_COURSES_NEW_FILTER_NAME,
  value,
})
export const onChangeGroupsNewFilterName = (value) => ({
  type: types.SET_GROUPS_NEW_FILTER_NAME,
  value,
})
export const setGroupsRowActiveIndex = (value) => ({
  type: types.SET_GROUP_ROW_SCROLL_INDEX,
  value,
})
export const setCoursesRowActiveIndex = (value) => ({
  type: types.SET_COURSE_ROW_SCROLL_INDEX,
  value,
})
export const setGroupsColumnDefs = (columnDefs) => ({
  type: types.SET_GROUPS_COLUMN_DEFS,
  columnDefs,
})
export const setGroupsColumnActiveIndex = (value) => ({
  type: types.SET_GROUP_COLUMN_SCROLL_INDEX,
  value,
})
export const setCoursesColumnActiveIndex = (value) => ({
  type: types.SET_COURSE_COLUMN_SCROLL_INDEX,
  value,
})
export const setShowCoursesFiltersOverlay = (value) => ({
  type: types.SET_SHOW_COURSES_FILTER_OVERALY,
  value,
})
export const setShowExternalReportsFiltersOverlay = (value) => ({
  type: types.SET_SHOW_EXTERNAL_REPORTS_FILTER_OVERALY,
  value,
})
export const setShowGroupsFiltersOverlay = (value) => ({
  type: types.SET_SHOW_GROUPS_FILTER_OVERALY,
  value,
})

export const setSelectedTab = (type, refetchData = false) => {
  return (dispatch, getState) => {
    const { selectedCourseManagerGroupsLocationGroups } =
      getState().managerReport
    dispatch(setManagerId(null))
    dispatch({ type: types.SET_SELECTED_TAB, selectedTab: type })
    dispatch(setSearchByData())
    dispatch(setBreadcrumbAll([]))
    dispatch(setBreadcrumb([]))
    // if(refetchData && type == 'courses'){
    // 	dispatch(getCourseManagerCoursesModule())
    // }else if (refetchData && type == 'groups') {
    // 	dispatch(selectCourseManagerGroupsLocationGroupCourse(selectedCourseManagerGroupsLocationGroups));
    // }
    if (type == 'courses') {
      dispatch(getCourseManagerCoursesModule())
    } else if (type == 'groups') {
      dispatch(
        selectCourseManagerGroupsLocationGroupCourse(
          selectedCourseManagerGroupsLocationGroups
        )
      )
    }
  }
}

export const setReferredFromTab = (tab) => {
  return (dispatch) => {
    dispatch({ type: types.SET_SELECTED_TAB, selectedTab: tab })
    dispatch(search(''))
  }
}

export const selectGroup = (group) => {
  const groupSelected = group ? (group.option ? group.option : group) : ''

  return (dispatch, getState) => {
    dispatch({ type: types.SELECT_GROUP, group: groupSelected })
    if (groupSelected) {
      dispatch(fetchGroupLocations(groupSelected))
    } else {
      dispatch(selectLocation([]))
    }
  }
}

export const selectGroups = (groups, stores) => {
  let selectedGroups = groups
    .map((group) => (group.option ? group.option : group))
    .filter((group) => !!group && !!group.id)

  return (dispatch, getState) => {
    const { areas } = getState().managerReport

    if (selectedGroups.find((item) => item.id == 'all')) {
      selectedGroups = [...areas.filter((item) => !!item.id)]
    }

    dispatch({ type: types.SELECT_GROUPS, groups: selectedGroups })
    dispatch(fetchGroupLocations(selectedGroups, stores))
  }
}

export const selectExternalReportsGroups = (groups) => {
  let groupsSelected = groups.map((group) =>
    group ? (group.option ? group.option : group) : ''
  )

  return (dispatch, getState) => {
    const { areas } = getState().managerReport

    if (groupsSelected.find((item) => item.id == 'all')) {
      groupsSelected = [...areas.filter((item) => !!item.id)]
    }

    dispatch({
      type: types.SELECT_EXTERNAL_REPORTS_GROUPS,
      payload: groupsSelected,
    })
    if (groupsSelected.length) {
      dispatch(fetchGroupLocations(groupsSelected))
    } else {
      dispatch(selectLocation([]))
    }
  }
}

export const selectExternalReportsGroup = (group) => {
  const groupSelected = group ? (group.option ? group.option : group) : ''

  return (dispatch, getState) => {
    dispatch({
      type: types.SELECT_EXTERNAL_REPORTS_GROUP,
      group: groupSelected,
    })
    if (groupSelected) {
      dispatch(fetchGroupLocations(groupSelected))
    } else {
      dispatch(selectLocation([]))
    }
  }
}

export const selectCategory = (group) => {
  const groupSelected = group ? (group.option ? group.option : group) : ''

  return (dispatch, getState) => {
    dispatch(clearCoursesFilter())
    dispatch(clearGroupsFilter())

    const { locationGroups } = getState().groups

    dispatch({ type: types.SELECT_CATEGORY, category: groupSelected })
    dispatch(setExportButtonState())

    if (group) {
      dispatch(fetchCategoryAreas(group.option))
    }

    // dispatch(type: types.SET_LOCATION_GROUPS,locationGroups
    // if (groupSelected) {
    // 	dispatch(fetchGroupLocations(groupSelected))
    // } else {
    // 	dispatch(selectLocation([]))
    // }
  }
}

export const selectEditGroupAndLocations = (item) => {
  return (dispatch, getState) => {
    const { locationGroups } = getState().groups
    const { stores, allStores } = getState().stores
    const { categories } = getState().managerReport

    dispatch({ type: types.SELECT_GROUP, group: [] })
    dispatch(selectLocation([]))
    dispatch({ type: types.SET_COURSE_SELECTED_ROLES, roles: [] })
    dispatch({ type: types.SELECT_CATEGORY, category: null })

    let storesSelected

    if (stores[0].name === 'Corporate') {
      storesSelected = allStores.filter(
        (store) =>
          item.module_id && item.module_id.includes(store.id.toString())
      )
    } else {
      storesSelected = stores.filter(
        (store) =>
          item.module_id && item.module_id.includes(store.id.toString())
      )
    }

    const groups = locationGroups.filter(
      (group) =>
        item.group_id && item.group_id.toString().includes(group.id.toString())
    )

    if (item.hasOwnProperty('category')) {
      const categorySelected = categories.find(
        (category) => category.id === parseInt(item.category)
      )

      dispatch({ type: types.SELECT_CATEGORY, category: categorySelected })
    }
    // const categorySelected =

    dispatch(selectGroups(groups))

    dispatch(selectLocation(storesSelected))

    const locationCourseIds = storesSelected.map((item) => item.id).toString()

    dispatch(setLoading(true, 'selectEditGroupAndLocations'))
    AxiosInstance.get(
      `/manager-reports/role-count?module_id=${locationCourseIds}&token=${accessToken()}`
    ).then((rolesCount) => {
      const rolesWithNumbers = []
      // let newRoles = roles.map((item, i) =>
      // 	Object.assign({}, item, rolesCount[i])
      // )

      rolesCount.map((item) => {
        item.name = item.name + ` (${item.count || 0})`
        rolesWithNumbers.push(item)
      })

      if (item.role_id && item.role_id.length > 0) {
        const selectedRoles =
          rolesCount &&
          rolesCount.length &&
          rolesCount.filter((role) => item.role_id.includes(role.id.toString()))

        dispatch({
          type: types.SET_COURSE_SELECTED_ROLES,
          roles: selectedRoles,
        })
      }

      dispatch({ type: types.SET_ROLES, rolesCount: rolesWithNumbers })
      dispatch(setLoading(false, 'selectEditGroupAndLocations'))
    })
  }
}

export const selectEditGroupAndLocationsExternalReports = (item) => {
  return (dispatch, getState) => {
    const { locationGroups } = getState().groups
    const { stores, allStores } = getState().stores

    const { categories } = getState().managerReport

    console.log(locationGroups, 'locationGroups')
    console.log(stores, 'stores')

    console.log(allStores, 'allStores')
    console.log(categories, 'categories')

    dispatch({ type: types.SELECT_EXTERNAL_REPORTS_GROUP, group: [] })
    dispatch(selectExternalReportsLocation([]))
    dispatch({ type: types.SET_EXTERNAL_REPORTS_SELECTED_ROLES, roles: [] })
    dispatch({ type: types.SELECT_CATEGORY, category: null })

    let storesSelected

    if (stores[0].name === 'Corporate') {
      storesSelected = allStores.filter(
        (store) =>
          item.module_id && item.module_id.includes(store.id.toString())
      )
    } else {
      storesSelected = stores.filter(
        (store) =>
          item.module_id && item.module_id.includes(store.id.toString())
      )
    }

    const groups = locationGroups.filter((group) =>
      item.group_id.toString().includes(group.id.toString())
    )

    // storesSelected = stores.filter(
    // 	(store) => item.module_id && item.module_id.includes(store.id.toString())
    // )

    dispatch(selectExternalReportsGroups(groups))

    dispatch(selectExternalReportsLocation(storesSelected))
    if (item.hasOwnProperty('category')) {
      const categorySelected = categories.find(
        (category) => category.id === parseInt(item.category)
      )

      dispatch({ type: types.SELECT_CATEGORY, category: categorySelected })
    }

    const locationCourseIds = storesSelected.map((item) => item.id).toString()

    dispatch(setLoading(true, 'selectEditGroupAndLocationsExternalReports'))
    AxiosInstance.get(
      `/manager-reports/role-count?module_id=${locationCourseIds}&token=${accessToken()}`
    ).then((rolesCount) => {
      const rolesWithNumbers = []
      // let newRoles = roles.map((item, i) =>
      // 	Object.assign({}, item, rolesCount[i])
      // )

      rolesCount.map((item) => {
        item.name = item.name + ` (${item.count || 0})`
        rolesWithNumbers.push(item)
      })

      if (item.role_id && item.role_id.length > 0) {
        const selectedRoles =
          rolesCount &&
          rolesCount.length &&
          rolesCount.filter((role) => item.role_id.includes(role.id.toString()))

        dispatch({
          type: types.SET_EXTERNAL_REPORTS_SELECTED_ROLES,
          roles: selectedRoles,
        })
      }

      dispatch({ type: types.SET_ROLES, rolesCount: rolesWithNumbers })
      dispatch(setLoading(false, 'selectEditGroupAndLocationsExternalReports'))
    })
  }
}

export const editCourseGroupFilter = (item, role) => {
  return (dispatch, getState) => {
    const { locationGroups } = getState().groups
    const { stores, allStores } = getState().stores
    const { learningPlanGroups } = getState().groups
    const { categories } = getState().managerReport

    dispatch({ type: types.SELECT_GROUP, group: [] })
    dispatch(selectLocation([]))
    dispatch({ type: types.SET_GROUPS_SELECTED_ROLES, roles: [] })
    dispatch({ type: types.SET_ROLES, rolesCount: [] })
    dispatch({ type: types.SELECT_CATEGORY, category: null })

    let storesSelected

    if (stores[0].name === 'Corporate') {
      storesSelected = allStores.filter(
        (store) =>
          item.module_id && item.module_id.includes(store.id.toString())
      )
    } else {
      storesSelected = stores.filter(
        (store) =>
          item.module_id && item.module_id.includes(store.id.toString())
      )
    }

    const groups = locationGroups.filter((group) =>
      item.group_id.toString().includes(group.id.toString())
    )
    // const storesSelected = stores.filter(
    // 	(store) => item.module_id && item.module_id.includes(store.id.toString())
    // )

    const learningPlanGroup = learningPlanGroups.find(
      (group) => group.id.toString() == item.curriculum_id
    )

    dispatch(selectGroupsGroups(groups))

    dispatch(selectGroupsLocation(storesSelected))

    dispatch(selectGroupsLocationGroupCourse(learningPlanGroup))
    if (item.hasOwnProperty('category')) {
      const categorySelected = categories.find(
        (category) => category.id === parseInt(item.category)
      )

      dispatch({ type: types.SELECT_CATEGORY, category: categorySelected })
    }

    const locationCourseIds = storesSelected.map((item) => item.id).toString()

    dispatch(setLoading(true, 'editCourseGroupFilter'))
    AxiosInstance.get(
      `/manager-reports/role-count?module_id=${locationCourseIds}&token=${accessToken()}`
    ).then((rolesCount) => {
      const rolesWithNumbers = []

      rolesCount.map((item) => {
        item.name = item.name + ` (${item.count || 0})`
        rolesWithNumbers.push(item)
      })

      if (item && item.role_id && item.role_id.length > 0) {
        const selectedRoles =
          rolesCount &&
          rolesCount.length &&
          rolesCount.filter((role) => item.role_id.includes(role.id.toString()))

        dispatch({
          type: types.SET_GROUPS_SELECTED_ROLES,
          roles: selectedRoles,
        })
      }

      dispatch({ type: types.SET_ROLES, rolesCount: rolesWithNumbers })
      dispatch(setLoading(false, 'editCourseGroupFilter'))
    })
  }
}

export const selectGroupsGroups = (groups) => {
  let groupsSelected = groups.map((group) =>
    group ? (group.option ? group.option : group) : ''
  )

  return (dispatch, getState) => {
    const { areas } = getState().managerReport

    if (groupsSelected.find((item) => item.id == 'all')) {
      groupsSelected = [...areas.filter((item) => !!item.id)]
    }

    dispatch({ type: types.SELECT_GROUPS_GROUPS, payload: groupsSelected })
    dispatch(fetchGroupsGroupLocations(groupsSelected))
    dispatch(fetchGroupsLocationGroupCourses(groupsSelected))
  }
}

export const selectGroupsGroup = (group) => {
  const groupSelected = group ? (group.option ? group.option : group) : ''

  return (dispatch) => {
    dispatch({ type: types.SELECT_GROUPS_GROUP, group: groupSelected })

    if (group) {
      dispatch(fetchGroupsGroupLocations(groupSelected))
      dispatch(fetchGroupsLocationGroupCourses(groupSelected))
    }
  }
}

export const selectLocation = (locations) => {
  let newLocations =
    locations.length && 'option' in locations[0]
      ? locations.map((loc) => loc.option)
      : locations.length
      ? locations
      : []

  return (dispatch, getState) => {
    const { groupLocations } = getState().managerReport

    if (newLocations.find((item) => item.id == 'all')) {
      newLocations = [...groupLocations]
    }

    dispatch({ type: types.SELECT_LOCATION, locations: newLocations })
    dispatch(setExportButtonState())

    if (locations.length) {
      dispatch(fetchRolesCounts())
    }
  }
}

export const selectGroupsLocation = (locations) => {
  return (dispatch, getState) => {
    let newLocations =
      locations.length && 'option' in locations[0]
        ? locations.map((loc) => loc.option)
        : locations.length
        ? locations
        : []

    const { selectedGroupsGroups, groupGroupsLocations } =
      getState().managerReport
    if (newLocations.find((item) => item.id == 'all')) {
      newLocations = [...groupGroupsLocations.filter((item) => !!item.id)]
    }

    dispatch({ type: types.SELECT_GROUPS_LOCATION, locations: newLocations })
    dispatch(setExportButtonState())
    if (locations.length) {
      dispatch(fetchGroupsLocationGroupCourses(selectedGroupsGroups))
      dispatch(fetchRolesCounts())
      // dispatch(getGroupsModule())
    }
  }
}

export const selectExternalReportsLocation = (locations) => {
  let newLocations =
    locations.length && 'option' in locations[0]
      ? locations.map((loc) => loc.option)
      : locations.length
      ? locations
      : []

  return (dispatch, getState) => {
    const { groupLocations } = getState().managerReport

    if (newLocations.find((item) => item.id == 'all')) {
      newLocations = [...groupLocations.filter((item) => !!item.id)]
    }

    dispatch({
      type: types.SELECT_EXTERNAL_REPORTS_LOCATION,
      locations: newLocations,
    })
    dispatch(setExportButtonState())

    if (locations.length) {
      dispatch(fetchRolesCounts())
    }
  }
}

export const selectGroupsLocationGroupCourse = (group) => {
  const newGroup = group ? (group.option ? group.option : group) : ''
  return (dispatch) => {
    dispatch({
      type: types.SET_SELECTED_GROUPS_LOCATION_GROUPS_COURSES,
      locationGroup: newGroup,
    })
    dispatch(setExportTrainingButtonState())
    dispatch(fetchRolesCounts())
  }
}

export const selectCoursesRoleCourseManager = (roles) => {
  return (dispatch) => {
    const roleIds = roles.map((role) => role.option.id).toString()

    dispatch({ type: types.SET_COURSE_SELECTED_ROLES, roles })

    if (callForRoles !== null) {
      callForRoles.cancel()
    }

    callForRoles = CancelToken.source()

    dispatch(setLoading(true, 'selectCoursesRoleCourseManager'))
    AxiosInstance.get(
      `/manager-reports?role_id=${roleIds}&token=${accessToken()}`,
      { cancelToken: callForRoles.token }
    )
      .then((data) => {
        let headerData = []

        if (data.header) {
          data.header.map((item, index) =>
            headerData.push({ index: index, name: item })
          )
        }

        const redefinedData = { data: data.data, header: headerData }

        dispatch({ type: types.SET_COURSE_MODULE, data: redefinedData })
      })
      .catch((thrown) => {
        if (axios.isCancel(thrown)) {
          console.log('selectRoles request canceled'), thrown.message //eslint-disable-line
        } else {
          dispatch({ type: types.RESET_ROLE })
          //handleError
        }
      })
      .then(() => dispatch(setLoading(false, 'selectCoursesRoleCourseManager')))
  }
}

export const selectCoursesRole = (roles) => {
  let newRoles = roles.map((role) => role.option)
  return (dispatch, getState) => {
    const { rolesCount } = getState().managerReport

    if (newRoles.find((item) => item.id == 'all')) {
      newRoles = [...rolesCount]
    }

    dispatch({ type: types.SET_COURSE_SELECTED_ROLES, roles: newRoles })
  }
}

export const selectGroupsRole = (roles) => {
  let newRoles = roles.map((role) => role.option)

  return (dispatch, getState) => {
    const { rolesCount } = getState().managerReport
    if (newRoles.find((item) => item.id == 'all')) {
      newRoles = [...rolesCount.filter((item) => !!item.id)]
    }

    dispatch({ type: types.SET_GROUPS_SELECTED_ROLES, roles: newRoles })
  }
}

export const selectExternalReportsRole = (roles) => {
  let newRoles = roles.map((role) => role.option)
  return (dispatch, getState) => {
    const { rolesCount } = getState().managerReport

    if (newRoles.find((item) => item.id == 'all')) {
      newRoles = [...rolesCount.filter((item) => !!item.id)]
    }

    dispatch({
      type: types.SET_EXTERNAL_REPORTS_SELECTED_ROLES,
      roles: newRoles,
    })
  }
}

export const selectGroupsRoleCourseManager = (roles) => {
  return (dispatch, getState) => {
    const { selectedCourseManagerGroupsLocationGroups } =
      getState().managerReport
    const roleIds = roles
      .map((role) => (role.option ? role.option.id : role.id))
      .toString()
    const { stores } = getState().stores

    dispatch({ type: types.SET_GROUPS_SELECTED_ROLES, roles })

    if (callForRoles !== null) {
      callForRoles.cancel()
    }

    callForRoles = CancelToken.source()

    if (roles.length) {
      dispatch(setLoading(true, 'selectGroupsRoleCourseManager'))
      AxiosInstance.get(
        `/manager-reports?group_id=${
          selectedCourseManagerGroupsLocationGroups.id
        }&module_id=&role_id=${roleIds}&token=${accessToken()}`,
        { cancelToken: callForRoles.token }
      )
        .then((data) => {
          let headerData = []

          if (data.header) {
            data.header.map((item, index) =>
              headerData.push({ index: index, name: item })
            )
          }

          const redefinedData = { data: data.data, header: headerData }

          dispatch({ type: types.SET_GROUPS_MODULE, data: redefinedData })
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            console.log('selectRoles request canceled'), thrown.message //eslint-disable-line
          }
        })
        .then(() =>
          dispatch(setLoading(false, 'selectGroupsRoleCourseManager'))
        )
    } else {
      dispatch({ type: types.SET_GROUPS_MODULE, data: null })
      dispatch(setGroupsRows([]))
      dispatch(setGroupsColumnDefs([]))

      dispatch({
        type: types.SELECT_COURSE_MANAGER_GROUP_LOCATION_GROUPS,
        group: selectedCourseManagerGroupsLocationGroups,
      })

      if (call3 !== null) {
        call3.cancel()
      }

      call3 = CancelToken.source()

      dispatch(setExportButtonStateCourseManager())

      if (selectedCourseManagerGroupsLocationGroups) {
        dispatch(setLoading(true, 'selectGroupsRoleCourseManager'))
        AxiosInstance.get(
          `/manager-reports/group/${
            selectedCourseManagerGroupsLocationGroups.id
          }?module_id=${stores.map((item) =>
            item.id.toString()
          )}&token=${accessToken()}`,
          { cancelToken: call3.token }
        )
          .then((data) => {
            let headerData = []
            if (data.header) {
              data.header.map((item, index) =>
                headerData.push({ index: index, name: item })
              )
            }
            const redefinedData = { data: data.data, header: headerData }

            dispatch({ type: types.SET_GROUPS_MODULE, data: redefinedData })
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              console.log('getModule request canceled'), thrown.message //eslint-disable-line
            }
          })
          .then(() =>
            dispatch(setLoading(false, 'selectGroupsRoleCourseManager'))
          )
      }
    }
  }
}

export const fetchGroupLocations = (group, storesState = []) => {
  return (dispatch, getState) => {
    const { stores } = getState().stores
    const { access } = getState().auth.user
    const ids = Array.isArray(group) ? group.map((item) => item.id) : [group.id]

    AxiosInstance.get(`/groups/${ids.join(',')}/locations`).then((data) => {
      if (Array.isArray(data)) {
        if (access === 5) {
          const locations = data.map((location) => {
            return {
              id: location.location_id,
              location_id: location.loc_id,
              name: location.name,
            }
          })

          dispatch({
            type: types.SET_GROUP_LOCATIONS,
            locations,
          })
        } else {
          const ids = data.map((item) => item.location_id)

          dispatch({
            type: types.SET_GROUP_LOCATIONS,
            locations: !storesState.length
              ? stores.filter((item) => ids.indexOf(item.id) !== -1)
              : storesState.filter((item) => ids.indexOf(item.id) !== -1),
          })
        }

        // dispatch(fetchRoles(group))
      }
    })
  }
}

export const fetchCategories = (group) => {
  return (dispatch, getState) => {
    const { stores } = getState().stores

    AxiosInstance.get(`/groups/categories`).then((data) => {
      dispatch({
        type: types.SET_CATEGORIES,
        categories: data,
      })
    })
  }
}

export const fetchCategoryAreas = (group) => {
  return (dispatch, getState) => {
    const { stores } = getState().stores

    AxiosInstance.get(`/groups/${group.id}/areas`).then((data) => {
      const { locationGroups } = getState().groups

      dispatch({
        type: types.SET_AREAS,
        areas: data,
      })
    })
  }
}

export const fetchLocationGroups = (query) => {
  return (dispatch, getState) => {
    // dispatch({ type: types.SET_LOCATIONS_LOADING, value: true })
    AxiosInstance.get(`/groups/details${query || ''}`).then((areas) => {
      const locationAreas = areas.filter((area) => area.type === 'location')

      dispatch({
        type: types.SET_AREAS,
        areas: locationAreas,
      })
    })
  }
}
export const fetchGroupsGroupLocations = (group) => {
  return (dispatch, getState) => {
    const { stores } = getState().stores
    const { access } = getState().auth.user

    const groupIds = Array.isArray(group)
      ? group.map((group) => group.id)
      : group.id

    AxiosInstance.get(`/groups/${groupIds}/locations`).then((data) => {
      if (Array.isArray(data)) {
        if (access === 5) {
          const locations = data.map((location) => {
            return {
              id: location.location_id,
              location_id: location.loc_id,
              name: location.name,
            }
          })

          dispatch({
            type: types.SET_GROUPS_GROUP_LOCATIONS,
            locations,
          })
        } else {
          const ids = data.map((item) => item.location_id)

          dispatch({
            type: types.SET_GROUPS_GROUP_LOCATIONS,
            locations: stores.filter((item) => ids.indexOf(item.id) !== -1),
          })
        }
      }
    })
  }
}

export const fetchGroupsLocationGroupCourses = (group) => {
  return (dispatch, getState) => {
    const { selectedGroupsLocations } = getState().managerReport

    call2 = CancelToken.source()

    const groupIds = Array.isArray(group)
      ? group.map((item) => item.id)
      : group.id

    if (group) {
      if (selectedGroupsLocations.length > 0) {
        AxiosInstance.get(
          `/groups/location-course-groups?group_id=${groupIds}&module_id=${selectedGroupsLocations
            .map((item) => item.id)
            .toString()}&token=${accessToken()}`,
          { cancelToken: call2.token }
        )
          .then((data) => {
            if (Array.isArray(data)) {
              dispatch({
                type: types.SET_LOCATION_GROUPS_COURSES,
                locationGroupCourses: data,
              })
            }
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              console.log('getModule request canceled'), thrown.message //eslint-disable-line
            }
          })
      } else {
        AxiosInstance.get(
          `/groups/location-course-groups?group_id=${groupIds}&token=${accessToken()}`,
          { cancelToken: call2.token }
        )
          .then((data) => {
            if (Array.isArray(data)) {
              dispatch({
                type: types.SET_LOCATION_GROUPS_COURSES,
                locationGroupCourses: data,
              })
            }
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              console.log('getModule request canceled'), thrown.message //eslint-disable-line
            }
          })
      }
    }
  }
}

export const setExportTrainingButtonState = () => {
  return (dispatch, getState) => {
    const { selectedGroupGroupsLocations } = getState().managerReport
    if (selectedGroupGroupsLocations) {
      dispatch({
        type: types.SET_EXPORT_TRAINING_BUTTON,
        exportTrainingButton: true,
      })
    } else {
      dispatch({
        type: types.SET_EXPORT_TRAINING_BUTTON,
        exportTrainingButton: false,
      })
    }
  }
}

export const setExportButtonStateCourseManager = () => {
  return (dispatch, getState) => {
    const { selectedCourseManagerGroupsLocationGroups } =
      getState().managerReport
    if (selectedCourseManagerGroupsLocationGroups) {
      dispatch({
        type: types.SET_EXPORT_TRAINING_BUTTON,
        exportTrainingButton: true,
      })
    } else {
      dispatch({
        type: types.SET_EXPORT_TRAINING_BUTTON,
        exportTrainingButton: false,
      })
    }
  }
}

export const setExportButtonState = () => {
  return (dispatch, getState) => {
    const {
      selectedCategories,
      selectedCoursesGroups,
      selectedCoursesLocations,
      selectedCoursesRole,
      selectedGroupsGroups,
      selectedGroupsLocations,
      selectedGroupGroupsLocations,
      selectedGroupsRole,
      selectedExternalReportsGroups,
      selectedExternalReportsLocations,
      selectedExternalReportsRole,
    } = getState().managerReport

    if (
      selectedGroupsGroups ||
      (selectedGroupsLocations && selectedGroupsLocations.length) ||
      selectedGroupGroupsLocations ||
      (selectedGroupsRole && selectedGroupsRole.length) ||
      selectedExternalReportsGroups ||
      (selectedExternalReportsLocations &&
        selectedExternalReportsLocations.length) ||
      (selectedExternalReportsRole && selectedExternalReportsRole.length) ||
      (selectedCoursesRole && selectedCoursesRole.length) ||
      selectedCoursesGroups ||
      (selectedCoursesLocations && selectedCoursesLocations.length) ||
      selectedCategories
    ) {
      dispatch({ type: types.SET_EXPORT_BUTTON, exportButton: true })
    } else {
      dispatch({ type: types.SET_EXPORT_BUTTON, exportButton: false })
    }
  }
}

export const setExportExternalReportsButtonState = () => {
  return (dispatch, getState) => {
    const { selectedExternalReportsLocations } = getState().managerReport

    if (selectedExternalReportsLocations.length) {
      dispatch({
        type: types.SET_EXPORT_EXTERNAL_REPORTS_BUTTON,
        exportExternalReportsButton: true,
      })
    } else {
      dispatch({
        type: types.SET_EXPORT_EXTERNAL_REPORTS_BUTTON,
        exportExternalReportsButton: false,
      })
    }
  }
}

export const getCoursesModule = (
  locations,
  roles,
  region = null,
  area = null
) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null
    const {
      selectedCoursesGroup,
      selectedCoursesGroups,
      selectedCoursesLocations,
      selectedCoursesRole,
    } = getState().managerReport
    const roleIds = roles.map((role) => role.id).toString()
    const groupId =
      selectedCoursesGroups && selectedCoursesGroups.length
        ? selectedCoursesGroups.map((item) => item.id).toString()
        : null
    const locationIds =
      selectedCoursesLocations.length > 0
        ? selectedCoursesLocations.map((item) => item.id).toString()
        : locations.map((item) => item.id).toString()

    if (region || area || (locations.length > 0 && !roles.length)) {
      let url = `/manager-reports?module_id=${locationIds}&token=${accessToken()}`
      if (region) {
        url += `&regionId=${region.id}`
      }
      if (area) {
        url += `&areaId=${
          Array.isArray(area) ? area.map((item) => item.id).toString() : area.id
        }`
      }
      if (roleIds) {
        url += `&role_id=${roleIds}`
      }

      dispatch(setLoading(true, 'getCoursesModule'))

      AxiosInstance.get(url, { cancelToken: call1.token })
        .then((data) => {
          if (!data.length) {
            dispatch({
              type: types.SET_COURSES_INFO_REPORT,
              value: language.manager_report
                ? language.manager_report.no_data
                : null,
            })
          }

          let headerData = []

          if (data.header) {
            data.header.map((item, index) =>
              headerData.push({ index: index, name: item })
            )
          }

          const redefinedData = { data: data.data, header: headerData }

          dispatch({ type: types.SET_COURSE_MODULE, data: redefinedData })
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            console.log('getModule request canceled'), thrown.message //eslint-disable-line
          }
        })
        .then(() => dispatch(setLoading(false, 'getCoursesModule')))
    } else if (locations.length > 0 && roles.length) {
      dispatch(setLoading(true, 'getCoursesModule'))
      AxiosInstance.get(
        `/manager-reports?group_id=${groupId}&module_id=${locationIds}&role_id=${roleIds}&token=${accessToken()}`,
        { cancelToken: callForRoles.token }
      ).then((data) => {
        let headerData = []

        if (data.header) {
          data.header.map((item, index) =>
            headerData.push({ index: index, name: item })
          )
        }

        const redefinedData = { data: data.data, header: headerData }

        dispatch({ type: types.SET_COURSE_MODULE, data: redefinedData })
        dispatch(setLoading(false, 'getCoursesModule'))
      })
    }
  }
}

export const getGroupsModule = () => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null
    const {
      selectedCategories,
      selectedGroupsGroup,
      selectedGroupsGroups,
      selectedGroupGroupsLocations,
      selectedGroupsLocations,
      selectedGroupsRole,
    } = getState().managerReport

    if (selectedGroupGroupsLocations) {
      dispatch(setLoading(true, 'getGroupsModule'))
      if (selectedGroupsLocations.length) {
        AxiosInstance.get(
          `/manager-reports/group/${selectedGroupGroupsLocations.id}?group_id=${
            selectedGroupsGroups
              ? selectedGroupsGroups.map((item) => item.id)
              : ''
          }&module_id=${selectedGroupsLocations.map((item) =>
            item.id.toString()
          )}&role_id=${selectedGroupsRole.map(
            (role) => role.id
          )}&token=${accessToken()}
						&regionId=${selectedCategories ? selectedCategories.id : ''}&areaId=${
            selectedGroupsGroups
              ? selectedGroupsGroups.map((item) => item.id)
              : ''
          }`,
          { cancelToken: call1.token }
        )
          .then((data) => {
            if (!data.length) {
              dispatch({
                type: types.SET_GROUPS_INFO_REPORT,
                value: language.manager_report
                  ? language.manager_report.no_data
                  : null,
              })
            }
            let headerData = []
            if (data.header) {
              data.header.map((item, index) =>
                headerData.push({ index: index, name: item })
              )
            }

            const redefinedData = { data: data.data, header: headerData }
            dispatch({ type: types.SET_GROUPS_MODULE, data: redefinedData })
            dispatch(fetchRolesCounts())
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              console.log('getModule request canceled'), thrown.message //eslint-disable-line
              dispatch(setLoading(true, 'getGroupsModule'))
            }
          })
          .then(() => dispatch(setLoading(false, 'getGroupsModule')))
      } else {
        AxiosInstance.get(
          `/manager-reports/group/${selectedGroupGroupsLocations.id}?group_id=${
            selectedGroupsGroups
              ? selectedGroupsGroups.map((item) => item.id)
              : ''
          }&token=${accessToken()}
						&regionId=${selectedCategories ? selectedCategories.id : ''}`,
          { cancelToken: call1.token }
        )
          .then((data) => {
            let headerData = []
            if (data.header) {
              data.header.map((item, index) =>
                headerData.push({ index: index, name: item })
              )
            }
            const redefinedData = { data: data.data, header: headerData }

            dispatch({ type: types.SET_GROUPS_MODULE, data: redefinedData })
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              console.log('getModule request canceled'), thrown.message //eslint-disable-line
              dispatch(setLoading(true, 'getGroupsModule'))
            }
          })
          .then(() => dispatch(setLoading(false, 'getGroupsModule')))
      }
    }
  }
}

export const getExternalReportsModule = (locations, roles) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null
    const {
      selectedExternalReportsGroup,
      selectedExternalReportsGroups,
      selectedExternalReportsLocations,
      selectedExternalReportsRole,
    } = getState().managerReport
    const roleIds = roles.map((role) => role.id).toString()
    const groupId =
      selectedExternalReportsGroups &&
      selectedExternalReportsGroups.map((item) => item.id).toString()
    const locationIds =
      selectedExternalReportsLocations.length > 0
        ? selectedExternalReportsLocations.map((item) => item.id).toString()
        : locations.map((item) => item.id).toString()

    if (locations.length > 0 && !roles.length) {
      dispatch(setLoading(true, 'getExternalReportsModule'))
      AxiosInstance.get(
        `/manager-reports/external-reports?module_id=${locationIds}&token=${accessToken()}`,
        { cancelToken: call1.token }
      )
        .then((data) => {
          if (!data.length) {
            dispatch({
              type: types.SET_EXTERNAL_REPORTS_INFO_REPORT,
              value: language.manager_report
                ? language.manager_report.no_data
                : null,
            })
          }

          let headerData = []

          if (data.header) {
            data.header.map((item, index) =>
              headerData.push({ index: index, name: item })
            )
          }

          const redefinedData = { data: data.data, header: headerData }

          dispatch({
            type: types.SET_EXTERNAL_REPORTS_MODULE,
            data: redefinedData,
          })
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            console.log('getModule request canceled'), thrown.message //eslint-disable-line
          }
        })
        .then(() => dispatch(setLoading(false, 'getExternalReportsModule')))
    } else if (locations.length > 0 && roles.length) {
      dispatch(setLoading(true, 'getExternalReportsModule'))
      AxiosInstance.get(
        `/manager-reports/external-reports?group_id=${groupId}&module_id=${locationIds}&role_id=${roleIds}&token=${accessToken()}`,
        { cancelToken: callForRoles.token }
      )
        .then((data) => {
          let headerData = []

          if (data.header) {
            data.header.map((item, index) =>
              headerData.push({ index: index, name: item })
            )
          }

          const redefinedData = { data: data.data, header: headerData }

          dispatch({
            type: types.SET_EXTERNAL_REPORTS_MODULE,
            data: redefinedData,
          })
        })
        .then(() => dispatch(setLoading(false, 'getExternalReportsModule')))
    }
  }
}

export const getAllGroupsModule = (props) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null
    // const { selectedGroupsRole } = getState().managerReport

    const selectedGroupsGroup = getState().stores.stores
    const selectedGroupGroupsLocations = getState().groups.learningPlanGroups
    const selectedGroupsLocations = getState().groups.locationGroups

    if (selectedGroupGroupsLocations) {
      dispatch(setLoading(true, 'getAllGroupsModule'))
      if (selectedGroupsLocations.length) {
        AxiosInstance.get(
          `/manager-reports/groups/${selectedGroupGroupsLocations.map((item) =>
            item.id.toString()
          )}?group_id=${selectedGroupsLocations.map((item) =>
            item.id.toString()
          )}&module_id=${selectedGroupsGroup.map((item) =>
            item.id.toString()
          )}&token=${accessToken()}`,
          { cancelToken: call1.token }
        )
          .then((data) => {
            if (!data.length) {
              dispatch({
                type: types.SET_GROUPS_INFO_REPORT,
                value: language.manager_report
                  ? language.manager_report.no_data
                  : null,
              })
            }
            let headerData = []
            if (data.header) {
              data.header.map((item, index) =>
                headerData.push({ index: index, name: item })
              )
            }

            const redefinedData = { data: data.data, header: headerData }
            dispatch({ type: types.SET_GROUPS_MODULE, data: redefinedData })
            dispatch(fetchRolesCounts())
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              console.log('getModule request canceled'), thrown.message //eslint-disable-line
              dispatch(setLoading(true, 'getAllGroupsModule'))
            }
          })
          .then(() => dispatch(setLoading(false, 'getAllGroupsModule')))
      } else {
        AxiosInstance.get(
          `/manager-reports/group/${selectedGroupGroupsLocations.id}?group_id=${
            selectedGroupsGroup.id
          }&token=${accessToken()}`,
          { cancelToken: call1.token }
        )
          .then((data) => {
            let headerData = []
            if (data.header) {
              data.header.map((item, index) =>
                headerData.push({ index: index, name: item })
              )
            }
            const redefinedData = { data: data.data, header: headerData }

            dispatch({ type: types.SET_GROUPS_MODULE, data: redefinedData })
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              console.log('getModule request canceled'), thrown.message //eslint-disable-line
              dispatch(setLoading(true, 'getAllGroupsModule'))
            }
          })
          .then(() => dispatch(setLoading(false, 'getAllGroupsModule')))
      }
    }
  }
}

export const getCourseManagerCoursesModule = (
  history = null,
  managerId = null
) => {
  return (dispatch, getState) => {
    if (call1 !== null) {
      dispatch(setLoading(true, 'getCourseManagerCoursesModule'))
      call1.cancel()
    }

    call1 = CancelToken.source()

    let url = `/manager-reports`

    console.log(url, 'URL')
    if (managerId) {
      url += `&managerId=${managerId}`
    }
    console.log(url, 'URL2')
    dispatch(setLoading(true, 'getCourseManagerCoursesModule'))

    AxiosInstance.get(url, {
      cancelToken: call1.token,
    })
      .then((data) => {
        let headerData = []

        if (data.header) {
          data.header.map((item, index) =>
            headerData.push({ index: index, name: item })
          )
        }

        if (data.data) {
          dispatch(addToBreadcrumbActive(managerId))
          dispatch(spliceBreadcrumb(managerId))
        } else if (!data.data && managerId) {
          history.push(`/manager-report/employee/${managerId}`)
        }

        const redefinedData = { data: data.data, header: headerData }
        dispatch({ type: types.SET_COURSE_MODULE, data: redefinedData })
        dispatch(setLoading(false, 'getCourseManagerCoursesModule'))
      })
      .catch((thrown) => {
        if (axios.isCancel(thrown)) {
          console.log('getModule request canceled'), thrown.message //eslint-disable-line
        } else {
          dispatch(setLoading(false, 'getCourseManagerCoursesModule'))
        }
      })
  }
}

export const setSearchByData = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_BY_DATA, searchByData: true })
    dispatch({ type: types.SET_SEARCH_BY_HEADER, searchByHeader: false })
    // dispatch({ type: types.SET_SEARCH_BY_CORE, searchByCore: false })
    dispatch(search(''))
  }
}

export const setSearchByHeader = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_BY_DATA, searchByData: false })
    // dispatch({ type: types.SET_SEARCH_BY_CORE, searchByCore: false })
    dispatch({ type: types.SET_SEARCH_BY_HEADER, searchByHeader: true })
    dispatch(search(''))
  }
}

export const setSearchByCore = (payload = false) => {
  console.log(payload, 'payload')
  return (dispatch) => {
    // dispatch({ type: types.SET_SEARCH_BY_DATA, searchByData: false })
    // dispatch({ type: types.SET_SEARCH_BY_HEADER, searchByHeader: false })
    dispatch({ type: types.SET_SEARCH_BY_CORE, searchByCore: payload })
    dispatch(search(''))
  }
}

export const onClickExportButton = () => {
  return (dispatch, getState) => {
    const {
      selectedCategories,
      selectedCoursesGroups,
      selectedCoursesLocations,
      selectedCoursesRole,
      selectedCoursesSavedFilter,
      managerId,
    } = getState().managerReport

    const { access, second_access } = getState().auth.user

    if (access === 2 || second_access === 2) {
      if (selectedCoursesRole.length) {
        window.open(
          clientBaseUrl() +
            `/manager-reports/export?role_id=${(selectedCoursesRole || []).map(
              (role) => role.id
            )}&token=${accessToken()}`,
          '_blank'
        )
      } else {
        window.open(
          clientBaseUrl() + `/manager-reports/export?token=${accessToken()}`,
          '_blank'
        )
      }
    } else {
      if (selectedCoursesLocations.length) {
        window.open(
          clientBaseUrl() +
            `/manager-reports/export?group_id=${
              selectedCoursesGroups
                ? selectedCoursesGroups.map((item) => item.id)
                : null
            }&module_id=${selectedCoursesLocations.map((item) =>
              item.id.toString()
            )}&managerId=${
              managerId ? managerId : null
            }&role_id=${selectedCoursesRole.map((role) => role.id)}&regionId=${
              selectedCategories ? selectedCategories.id : null
            }&token=${accessToken()}`,
          '_blank'
        )
      } else if (selectedCoursesSavedFilter) {
        window.open(
          clientBaseUrl() +
            `/manager-reports/export?group_id=${
              selectedCoursesSavedFilter.group_id
            }&module_id=${selectedCoursesSavedFilter.module_id.map(
              (item) => item
            )}&role_id=${
              selectedCoursesSavedFilter.role_id
                ? selectedCoursesSavedFilter.role_id.map((role) => role)
                : ''
            }&token=${accessToken()}`,
          '_blank'
        )
      } else {
        window.open(
          clientBaseUrl() +
            `/manager-reports/export?group_id=${
              selectedCoursesGroups
                ? selectedCoursesGroups.map((item) => item.id)
                : null
            }&managerId=${
              managerId ? managerId : null
            }&role_id=${selectedCoursesRole.map((role) => role.id)}&regionId=${
              selectedCategories ? selectedCategories.id : null
            }&token=${accessToken()}`,
          '_blank'
        )
      }
    }
  }
}

export const onClickExportTrainingButton = () => {
  return (dispatch, getState) => {
    const {
      selectedGroupsGroup,
      selectedGroupsLocations,
      selectedGroupGroupsLocations,
      selectedGroupsRole,
      selectedGroupsSavedFilter,
    } = getState().managerReport

    if (selectedGroupGroupsLocations) {
      window.open(
        clientBaseUrl() +
          `/manager-reports/group/${
            selectedGroupGroupsLocations.id
          }/export?group_id=${
            selectedGroupsGroup.id
          }&module_id=${selectedGroupsLocations.map((item) =>
            item.id.toString()
          )}&role_id=${selectedGroupsRole.map(
            (role) => role.id
          )}&token=${accessToken()}`,
        '_blank'
      )
    } else if (selectedGroupsSavedFilter) {
      window.open(
        clientBaseUrl() +
          `/manager-reports/group/${
            selectedGroupsSavedFilter.curriculum_id
          }/export?group_id=${
            selectedGroupsSavedFilter.group_id
          }&module_id=${selectedGroupsSavedFilter.module_id.map(
            (item) => item
          )}&role_id=${
            selectedGroupsSavedFilter.roles
              ? selectedGroupsSavedFilter.role_id.map((role) => role.id)
              : ''
          }&token=${accessToken()}`,
        '_blank'
      )
    } else {
      window.open(
        clientBaseUrl() +
          `/manager-reports/group/${
            selectedGroupGroupsLocations.id
          }/export?group_id=${
            selectedGroupsGroup.id
          }&role_id=${selectedGroupsRole.map(
            (role) => role.id
          )}&token=${accessToken()}`,
        '_blank'
      )
    }
  }
}

export const onClickExportExternalReportsButton = () => {
  return (dispatch, getState) => {
    const {
      selectedExternalReportsGroup,
      selectedExternalReportsLocations,
      selectedExternalReportsRole,
      selectedExternalReportsSavedFilter,
    } = getState().managerReport
    const { access, second_access } = getState().auth.user
    if (access === 2 || second_access === 2) {
      if (selectedExternalReportsRole.length) {
        window.open(
          clientBaseUrl() +
            `/manager-reports/export/external-reports?role_id=${(
              selectedExternalReportsRole || []
            ).map((role) => role.id)}&token=${accessToken()}`,
          '_blank'
        )
      } else {
        window.open(
          clientBaseUrl() +
            `/manager-reports/export/external-reports?token=${accessToken()}`,
          '_blank'
        )
      }
    } else {
      if (selectedExternalReportsLocations.length) {
        window.open(
          clientBaseUrl() +
            `/manager-reports/export/external-reports?group_id=${
              selectedExternalReportsGroup.id
            }&module_id=${selectedExternalReportsLocations.map((item) =>
              item.id.toString()
            )}&role_id=${selectedExternalReportsRole.map(
              (role) => role.id
            )}&token=${accessToken()}`,
          '_blank'
        )
      } else if (selectedExternalReportsSavedFilter) {
        window.open(
          clientBaseUrl() +
            `/manager-reports/export/external-reports?group_id=${
              selectedExternalReportsSavedFilter.group_id
            }&module_id=${selectedExternalReportsSavedFilter.module_id.map(
              (item) => item
            )}&role_id=${
              selectedExternalReportsSavedFilter.role_id
                ? selectedExternalReportsSavedFilter.role_id.map((role) => role)
                : ''
            }&token=${accessToken()}`,
          '_blank'
        )
      } else {
        window.open(
          clientBaseUrl() +
            `/manager-reports/export/external-reports?group_id=${
              selectedExternalReportsGroup.id
            }&role_id=${selectedExternalReportsRole.map(
              (role) => role.id
            )}&token=${accessToken()}`,
          '_blank'
        )
      }
    }
  }
}

export const onClickCourseManagerExportTrainingButton = () => {
  return (dispatch, getState) => {
    const { stores } = getState().stores
    const { selectedGroupsRole, selectedCourseManagerGroupsLocationGroups } =
      getState().managerReport

    window.open(
      clientBaseUrl() +
        `/manager-reports/group/${
          selectedCourseManagerGroupsLocationGroups.id
        }/export?module_id=${stores.map((item) =>
          item.id.toString()
        )}&role_id=${selectedGroupsRole.map(
          (role) => role.id
        )}&token=${accessToken()}`,
      '_blank'
    )
  }
}

export const setCourseManagerGroupsLocationGroupCourse = () => {
  return (dispatch, getState) => {
    const { stores } = getState().auth.user.auth.user
    AxiosInstance.get(
      `/groups/location-course-groups?module_id=${stores.map((item) =>
        item.id.toString()
      )}`
    ).then((data) => {
      dispatch({
        type: types.SET_COURSE_MANAGER_COURSE_GROUPS,
        locationGroups: data,
      })
    })
  }
}

export const selectCourseManagerGroupsLocationGroupCourse = (group) => {
  if (group && group.hasOwnProperty('option')) {
    group = group.option
  }

  return (dispatch, getState) => {
    const { stores } = getState().stores
    const { selectedCourseManagerGroupsLocationGroups, managerId } =
      getState().managerReport

    dispatch({ type: types.SELECT_COURSE_MANAGER_GROUP_LOCATION_GROUPS, group })

    if (call3 !== null) {
      call3.cancel()
    }

    call3 = CancelToken.source()

    dispatch(setExportButtonStateCourseManager())

    if (group) {
      let link = `/manager-reports/group/${group.id}?module_id=${stores.map(
        (item) => item.id.toString()
      )}&token=${accessToken()}`

      if (managerId) {
        link += `&managerId=${managerId}`
      }

      dispatch(setLoading(true, 'selectCourseManagerGroupsLocationGroupCourse'))
      AxiosInstance.get(link, { cancelToken: call3.token })
        .then((data) => {
          let headerData = []
          if (data.header) {
            data.header.map((item, index) =>
              headerData.push({ index: index, name: item })
            )
          }
          const redefinedData = { data: data.data, header: headerData }

          if (data.data) {
            dispatch(addToBreadcrumbActive(managerId))
            dispatch(spliceBreadcrumb(managerId))
          } else if (!data.data && managerId) {
            history.push(`/manager-report/employee/${managerId}`) //eslint-disable-line
          }

          dispatch({ type: types.SET_GROUPS_MODULE, data: redefinedData })
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            console.log('getModule request canceled'), thrown.message //eslint-disable-line
          }
        })
        .then(() =>
          dispatch(
            setLoading(false, 'selectCourseManagerGroupsLocationGroupCourse')
          )
        )
    } else {
      dispatch({ type: types.SET_GROUPS_MODULE, data: null })
      dispatch(setGroupsRows([]))
      dispatch(setGroupsColumnDefs([]))
      dispatch(setExportTrainingButtonState())
    }
  }
}

export const setCoursesFilter = () => {
  return (dispatch, getState) => {
    const {
      selectedCategories,
      selectedCoursesGroups,
      selectedCoursesLocations,
      selectedCoursesRole,
    } = getState().managerReport

    const { stores } = getState().stores

    dispatch(
      getCoursesModule(
        selectedCoursesLocations,
        selectedCoursesRole,
        selectedCategories,
        selectedCoursesGroups
      )
    )
    dispatch(setShowCoursesFiltersOverlay(false))
  }
}

export const setExternalReportsFilter = () => {
  return (dispatch, getState) => {
    const { selectedExternalReportsLocations, selectedExternalReportsRole } =
      getState().managerReport

    dispatch(
      getExternalReportsModule(
        selectedExternalReportsLocations,
        selectedExternalReportsRole
      )
    )
    dispatch(setShowExternalReportsFiltersOverlay(false))
  }
}

export const setAllCoursesData = () => {
  return (dispatch, getState) => {
    const { selectedCoursesLocations, selectedCoursesRole } =
      getState().managerReport

    const { stores } = getState().stores

    dispatch(getCoursesModule(stores, selectedCoursesRole))
    dispatch(setShowCoursesFiltersOverlay(false))
  }
}

// export const setAllCourses = () => {
//   return (dispatch, getState) => {
//     const {
//       selectedCoursesLocations,
//       selectedCoursesRole
//     } = getState().managerReport
//     dispatch(getCoursesModule(selectedCoursesLocations, selectedCoursesRole))
//     dispatch(setShowCoursesFiltersOverlay(false))
//   }}

export const setGroupsFilter = () => {
  return (dispatch) => {
    dispatch(getGroupsModule())
    dispatch(setShowGroupsFiltersOverlay(false))
  }
}

export const setAllGroupsFilter = () => {
  return (dispatch) => {
    dispatch(getGroupsModule())
    dispatch(setShowGroupsFiltersOverlay(false))
  }
}

export const saveEditedExternalReportFilter = (item) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null
    const {
      selectedCategories,
      selectedExternalReportsGroups,
      selectedExternalReportsLocations,
      selectedExternalReportsRole,
    } = getState().managerReport

    const data = {
      id: item.id,
      name: item.name.trim(),
      scope: 'public',
      type: 'external-reports',
      category: selectedCategories ? parseInt(selectedCategories.id) : '',
      group_id: selectedExternalReportsGroups
        ? selectedExternalReportsGroups.map((item) => parseInt(item.id))
        : [],
      module_id: selectedExternalReportsLocations.map((item) =>
        parseInt(item.id)
      ),
      role_id: selectedExternalReportsRole.map((item) => parseInt(item.id)),
    }
    dispatch(setLoading(true, 'saveEditedExternalReportFilter'))
    AxiosInstance.put(`/manager-reports/user/save-filter`, data).then(() => {
      data.option = data
      dispatch(setShowCoursesFiltersOverlay(false))
      dispatch(fetchUsersSavedFilters())
      dispatch(onChangeNewFilterName(''))
      dispatch(selectExternalReportsSavedFilter(data))
      dispatch(setLoading(false, 'saveEditedExternalReportFilter'))
    })
  }
}

export const saveEditedFilter = (item) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null
    const {
      selectedCoursesGroups,
      selectedCoursesLocations,
      selectedCoursesRole,
      selectedCategories,
    } = getState().managerReport

    const data = {
      id: item.id,
      name: item.name.trim(),
      scope: 'public',
      type: 'courses',
      category: selectedCategories ? parseInt(selectedCategories.id) : '',
      group_id: selectedCoursesGroups
        ? selectedCoursesGroups.map((item) => parseInt(item.id))
        : [],
      module_id: selectedCoursesLocations.map((item) => parseInt(item.id)),
      role_id: selectedCoursesRole.map((item) => parseInt(item.id)),
    }
    dispatch(setLoading(true, 'saveEditedFilter'))
    AxiosInstance.put(`/manager-reports/user/save-filter`, data).then(() => {
      data.option = data
      dispatch(setShowCoursesFiltersOverlay(false))
      dispatch(fetchUsersSavedFilters())
      dispatch(onChangeNewFilterName(''))
      dispatch(selectExternalReportsSavedFilter(data))
      dispatch(setLoading(false, 'saveEditedFilter'))
    })
  }
}
export const saveCoursesFilter = () => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null

    const {
      selectedCoursesGroups,
      selectedCoursesLocations,
      selectedCoursesRole,
      savedCoursesFilters,
      selectedCategories,
    } = getState().managerReport

    const newFilterName = prompt(
      language.data.alerts
        ? language.data.alerts.enter_filter_name_to_save
        : null
    )
    let randomId = randomString()
    const checkExistingFilter = newFilterName
      ? savedCoursesFilters.findIndex(
          (item) =>
            item.name.toLowerCase().trim() ===
            newFilterName.toLowerCase().trim()
        )
      : null

    if (newFilterName.trim()) {
      if (checkExistingFilter === -1) {
        const data = {
          id: randomId,
          name: newFilterName.trim(),
          scope: 'public',
          type: 'courses',
          category: selectedCategories ? parseInt(selectedCategories.id) : '',
          group_id: selectedCoursesGroups
            ? selectedCoursesGroups.map((item) => parseInt(item.id))
            : [],
          module_id: selectedCoursesLocations.map((item) => parseInt(item.id)),
          role_id: selectedCoursesRole.map((item) => parseInt(item.id)),
        }

        dispatch(setLoading(true, 'saveCoursesFilter'))
        AxiosInstance.post(`/manager-reports/user/save-filter`, data).then(
          () => {
            data.option = data
            dispatch(setShowCoursesFiltersOverlay(false))
            dispatch(fetchUsersSavedFilters())
            dispatch(onChangeNewFilterName(''))
            dispatch(selectCoursesSavedFilter(data))
            dispatch(setLoading(false, 'saveCoursesFilter'))
          }
        )
      } else {
        alert(language.alerts ? language.alerts.filter_already_exists : null)
        dispatch(saveCoursesFilter())
      }
    } else if (newFilterName !== null) {
      alert(language.alerts ? language.alerts.type_filter_name : null)
      dispatch(saveCoursesFilter())
    } else return
  }
}

export const saveExternalReportsFilter = () => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null
    const {
      selectedExternalReportsGroups,
      selectedExternalReportsLocations,
      selectedExternalReportsRole,
      savedExternalReportsFilters,
      selectedCategories,
    } = getState().managerReport

    const newFilterName = prompt(
      language.data.alerts
        ? language.data.alerts.enter_filter_name_to_save
        : null
    )
    let randomId = randomString()
    const checkExistingFilter = newFilterName
      ? savedExternalReportsFilters
        ? savedExternalReportsFilters.findIndex(
            (item) =>
              item.name.toLowerCase().trim() ===
              newFilterName.toLowerCase().trim()
          )
        : -1
      : null

    if (newFilterName.trim()) {
      if (checkExistingFilter === -1) {
        const data = {
          id: randomId,
          name: newFilterName.trim(),
          scope: 'public',
          type: 'external-reports',
          group_id: selectedExternalReportsGroups.map((item) =>
            parseInt(item.id)
          ),
          category: selectedCategories ? parseInt(selectedCategories.id) : '',
          module_id: selectedExternalReportsLocations.map((item) =>
            parseInt(item.id)
          ),
          role_id: selectedExternalReportsRole.map((item) => parseInt(item.id)),
        }

        dispatch(setLoading(true, 'saveExternalReportsFilter'))
        AxiosInstance.post(`/manager-reports/user/save-filter`, data, {
          transformRequest: [
            (data, headers) => {
              if (data && data.FormData) {
                return data
              }
              return qs.stringify(data)
            },
          ],
        }).then(() => {
          data.option = data
          dispatch(setShowCoursesFiltersOverlay(false))
          dispatch(fetchUsersSavedFilters())
          dispatch(onChangeNewFilterName(''))
          dispatch(selectExternalReportsSavedFilter(data))
          dispatch(setLoading(false, 'saveExternalReportsFilter'))
        })
      } else {
        alert(language.alerts ? language.alerts.filter_already_exists : null)
        dispatch(saveExternalReportsFilter())
      }
    } else if (newFilterName !== null) {
      alert(language.alerts ? language.alerts.type_filter_name : null)
      dispatch(saveExternalReportsFilter())
    } else return
  }
}

export const saveEditedGroupsFilter = (item) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language) //eslint-disable-line.data)
      : null
    const {
      selectedGroupsGroups,
      selectedGroupsLocations,
      selectedGroupsRole,
      selectedGroupGroupsLocations,
      savedGroupsFilters,
      selectedCategories,
    } = getState().managerReport

    const data = {
      id: item.id,
      name: item.name.trim(),
      scope: 'public',
      type: 'groups',
      category: selectedCategories ? parseInt(selectedCategories.id) : '',
      group_id: selectedGroupsGroups.map((item) => parseInt(item.id)),
      module_id: selectedGroupsLocations.map((item) => parseInt(item.id)),
      role_id: selectedGroupsRole.map((item) => parseInt(item.id)),
      curriculum_id: parseInt(selectedGroupGroupsLocations.id),
    }

    dispatch(setLoading(true, 'saveEditedGroupsFilter'))
    AxiosInstance.put(`/manager-reports/user/save-filter`, data).then(() => {
      dispatch(setShowGroupsFiltersOverlay(false))
      dispatch(fetchUsersSavedFilters())
      dispatch(onChangeGroupsNewFilterName(''))
      dispatch(selectGroupsSavedFilter(data))
      dispatch(setLoading(false, 'saveEditedGroupsFilter'))
    })
  }
}

export const saveGroupsFilter = () => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null
    const {
      selectedGroupsGroups,
      selectedGroupsLocations,
      selectedGroupsRole,
      selectedGroupGroupsLocations,
      savedGroupsFilters,
      selectedCategories,
    } = getState().managerReport

    const newFilterName = prompt(
      language.data.alerts
        ? language.data.alerts.enter_filter_name_to_save
        : null
    )

    let randomId = randomString()

    const checkExistingFilter = savedGroupsFilters.findIndex(
      (item) =>
        item.name.toLowerCase().trim() === newFilterName.toLowerCase().trim()
    )
    if (newFilterName.trim()) {
      if (checkExistingFilter === -1) {
        const data = {
          id: randomId,
          name: newFilterName.trim(),
          scope: 'public',
          type: 'groups',
          group_id: selectedGroupsGroups.map((item) => parseInt(item.id)),
          category: selectedCategories ? parseInt(selectedCategories.id) : '',
          module_id: selectedGroupsLocations.map((item) => parseInt(item.id)),
          role_id: selectedGroupsRole.map((item) => parseInt(item.id)),
          curriculum_id: parseInt(selectedGroupGroupsLocations.id),
        }

        dispatch(setLoading(true, 'saveGroupsFilter'))
        AxiosInstance.post(`/manager-reports/user/save-filter`, data).then(
          () => {
            data.option = data
            dispatch(setShowGroupsFiltersOverlay(false))
            dispatch(fetchUsersSavedFilters())
            dispatch(onChangeGroupsNewFilterName(''))
            dispatch(selectGroupsSavedFilter(data))
            dispatch(setLoading(false, 'saveGroupsFilter'))
          }
        )
      } else {
        alert(language.alerts ? language.alerts.filter_already_exists : null)
        dispatch(saveGroupsFilter())
      }
    } else {
      alert(language.alerts ? language.alerts.type_filter_name : null)
      dispatch(saveGroupsFilter())
    }
  }
}

export const deleteSavedFilter = (filterId) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null
    const { id } = getState().auth.user
    // if (
    //   confirm(
    //     language.alerts
    //       ? language.alerts.delete_filter_confirm
    //       : 'Are you sure to delete the filter?'
    //   ) //eslint-disable-line
    // ) {
    AxiosInstance.delete(
      `/manager-reports/user/${id}/filters/${filterId}`
    ).then((response) => {
      dispatch(fetchUsersSavedFilters())
    })
    // }
  }
}

export const fetchUsersSavedFilters = () => {
  return (dispatch, getState) => {
    const { id } = getState().auth.user

    dispatch(setLoading(true, 'fetchUsersSavedFilters'))
    AxiosInstance.get(`/manager-reports/user/${id}/filters`).then((data) => {
      dispatch(setLoading(false, 'fetchUsersSavedFilters'))
      if (data) {
        dispatch({
          type: types.SET_SAVED_FILTERS,
          savedCoursesFilters: JSON.parse(data.report_filters).filter(
            (item) => item.type === 'courses'
          ),
          savedGroupsFilters: JSON.parse(data.report_filters).filter(
            (item) => item.type === 'groups'
          ),
          savedExternalReportsFilters: JSON.parse(data.report_filters).filter(
            (item) => item.type === 'external-reports'
          ),
        })
      } else {
        dispatch({
          type: types.SET_SAVED_FILTERS,
          savedCoursesFilters: [],
          savedGroupsFilters: [],
        })
      }
    })
  }
}

export const selectCoursesSavedFilter = (value) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null

    const valueOption = value === null ? '' : value.option
    if (valueOption) {
      dispatch({ type: types.SET_SELECTED_SAVED_FILTER, value: value.option })
      dispatch({ type: types.SET_EXPORT_BUTTON, exportButton: true })
      dispatch(setLoading(true, 'selectCoursesSavedFilter'))

      AxiosInstance.get(
        `/manager-reports?${
          value.option.group_id
            ? `group_id=${value.option.group_id}&areaId=${value.option.group_id}&`
            : ''
        }regionId=${value.option.category}&module_id=${
          value.option.module_id
            ? value.option.module_id.map((item) => item)
            : []
        }&role_id=${
          value.option.role_id && value.option.role_id.length
            ? value.option.role_id.map((item) => item)
            : []
        }`
      ).then((data) => {
        console.log(data, 'data e veqant')
        dispatch(setLoading(false, 'selectCoursesSavedFilter'))
        dispatch(setShowCoursesFiltersOverlay(false))
        let headerData = []
        if (!data.data && !data.header) {
          dispatch({
            type: types.SET_COURSES_INFO_REPORT,
            value: language.manager_report
              ? language.manager_report.no_data
              : null,
          })

          dispatch({ type: types.CLEAR_COURSES_DATA })
          dispatch({ type: types.SET_COURSE_MODULE, data: null })
          dispatch({ type: types.SET_EXPORT_BUTTON, exportButton: false })
          return
        }

        if (data.header) {
          data.header.map((item, index) =>
            headerData.push({ index: index, name: item })
          )
        }

        const redefinedData = { data: data.data, header: headerData }
        dispatch({ type: types.SET_COURSES_INFO_REPORT, value: '' })
        dispatch({ type: types.SET_COURSE_MODULE, data: redefinedData })
      })
    } else {
      dispatch({ type: types.CLEAR_COURSES_DATA })
      dispatch({ type: types.SET_COURSE_MODULE, data: null })
      dispatch({ type: types.SET_SELECTED_SAVED_FILTER, value: null })

      dispatch({ type: types.SET_EXPORT_BUTTON, exportButton: false })
      dispatch({ type: types.SET_COURSES_INFO_REPORT, value: '' })
    }
  }
}

export const selectGroupsSavedFilter = (value) => {
  return (dispatch, getState) => {
    let language = {}

    const valueOption = value === null ? '' : value.option
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null
    if (valueOption) {
      dispatch({
        type: types.SET_SELECTED_GROUPS_SAVED_FILTER,
        value: value.option,
      })
      dispatch({
        type: types.SET_EXPORT_TRAINING_BUTTON,
        exportTrainingButton: true,
      })

      dispatch(setLoading(true, 'selectGroupsSavedFilter'))
      AxiosInstance.get(
        `/manager-reports/group/${valueOption.curriculum_id}?group_id=${
          valueOption.group_id
        }&module_id=${(valueOption.module_id || []).map(
          (item) => item
        )}&role_id=${
          valueOption.role_id && valueOption.role_id.length
            ? valueOption.role_id.map((item) => item)
            : []
        }`
      ).then((data) => {
        dispatch(setShowGroupsFiltersOverlay(false))
        dispatch(setLoading(false, 'selectGroupsSavedFilter'))
        let headerData = []
        if (!data.data && !data.header) {
          dispatch({
            type: types.SET_GROUPS_INFO_REPORT,
            value: language.manager_report
              ? language.manager_report.no_data
              : null,
          })
          dispatch({ type: types.SET_GROUPS_MODULE, data: null })
          dispatch({ type: types.CLEAR_GROUPS_DATA })
          dispatch({
            type: types.SET_EXPORT_TRAINING_BUTTON,
            exportTrainingButton: false,
          })
          return
        }

        if (data.header) {
          data.header.map((item, index) =>
            headerData.push({ index: index, name: item })
          )
        }

        const redefinedData = { data: data.data, header: headerData }
        dispatch({ type: types.SET_GROUPS_INFO_REPORT, value: '' })
        dispatch({ type: types.SET_GROUPS_MODULE, data: redefinedData })
      })
    } else {
      dispatch({ type: types.SET_GROUPS_MODULE, data: null })
      dispatch({ type: types.CLEAR_GROUPS_DATA })
      dispatch({ type: types.SET_SELECTED_GROUPS_SAVED_FILTER, value: null })
      dispatch({
        type: types.SET_EXPORT_TRAINING_BUTTON,
        exportTrainingButton: false,
      })
      dispatch({ type: types.SET_GROUPS_INFO_REPORT, value: '' })
    }
  }
}

export const selectExternalReportsSavedFilter = (value) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language)
      : null

    const valueOption = value === null ? '' : value.option
    if (valueOption) {
      dispatch({
        type: types.SET_SELECTED_EXTERNAL_REPORTS_SAVED_FILTER,
        value: value.option,
      })
      dispatch({
        type: types.SET_EXPORT_EXTERNAL_REPORTS_BUTTON,
        exportExternalReportsButton: true,
      })

      dispatch(setLoading(true, 'selectExternalReportsSavedFilter'))
      AxiosInstance.get(
        `/manager-reports/external-reports?group_id=${
          value.option.group_id
        }&module_id=${value.option.module_id.map((item) => item)}&role_id=${
          value.option.role_id && value.option.role_id.length
            ? value.option.role_id.map((item) => item)
            : []
        }`
      ).then((data) => {
        dispatch(setShowExternalReportsFiltersOverlay(false))
        let headerData = []
        if (!data.data && !data.header) {
          dispatch({
            type: types.SET_EXTERNAL_REPORTS_INFO_REPORT,
            value: language.manager_report
              ? language.manager_report.no_data
              : null,
          })
          dispatch({ type: types.CLEAR_EXTERNAL_REPORTS_DATA })
          dispatch({ type: types.SET_EXTERNAL_REPORTS_MODULE, data: null })
          dispatch({
            type: types.SET_EXPORT_EXTERNAL_REPORTS_BUTTON,
            exportExternalReportsButton: false,
          })
          return
        }

        if (data.header) {
          data.header.map((item, index) =>
            headerData.push({ index: index, name: item })
          )
        }

        const redefinedData = { data: data.data, header: headerData }

        dispatch({ type: types.SET_EXTERNAL_REPORTS_INFO_REPORT, value: '' })
        dispatch({
          type: types.SET_EXTERNAL_REPORTS_MODULE,
          data: redefinedData,
        })
        dispatch(setLoading(false, 'selectExternalReportsSavedFilter'))
      })
    } else {
      dispatch({ type: types.CLEAR_EXTERNAL_REPORTS_DATA })
      dispatch({ type: types.SET_EXTERNAL_REPORTS_MODULE, data: null })
      dispatch({
        type: types.SET_SELECTED_EXTERNAL_REPORTS_SAVED_FILTER,
        value: null,
      })
      dispatch({
        type: types.SET_EXPORTSET_EXPORT_EXTERNAL_REPORTS_BUTTON_BUTTON,
        exportExternalReportsButton: false,
      })
      dispatch({ type: types.SET_EXTERNAL_REPORTS_INFO_REPORT, value: '' })
    }
  }
}

export const clearCoursesFilter = () => {
  return (dispatch) => {
    dispatch({ type: types.CLEAR_COURSES_FILTER_DATA })
    dispatch({ type: types.SET_EXPORT_BUTTON, exportButton: false })
  }
}

export const resetRefetchManagerReportsCourses = () => ({
  type: types.RESET_REFETCH_MANAGER_REPORTS_COURSES,
})

export const refetchManagerReportsCourses = () => ({
  type: types.REFETCH_MANAGER_REPORTS_COURSES,
})

export const clearGroupsFilter = () => {
  return (dispatch) => {
    dispatch({ type: types.CLEAR_GROUPS_FILTER_DATA })
    dispatch({
      type: types.SET_EXPORT_TRAINING_BUTTON,
      exportTrainingButton: false,
    })
  }
}

export const clearExternalReportsFilter = () => {
  return (dispatch) => {
    dispatch({ type: types.CLEAR_EXTERNAL_REPORTS_FILTER_DATA })
    dispatch({
      type: types.SET_EXPORT_EXTERNAL_REPORTS_BUTTON,
      exportExternalReportsButton: false,
    })
  }
}

export const fetchRolesCounts = () => {
  return (dispatch, getState) => {
    const {
      selectedCoursesLocations,
      selectedExternalReportsLocations,
      selectedGroupsLocations,
      selectedGroupGroupsLocations,
      selectedGroupsGroups,
      selectedTab,
    } = getState().managerReport

    const { roles } = getState().roles

    const locationCourseIds = selectedCoursesLocations
      .map((item) => item.id)
      .toString()

    const locationGroupIds = selectedGroupsLocations
      .map((item) => item.id)
      .toString()

    const locationExternalReportsIds = selectedExternalReportsLocations
      .map((item) => item.id)
      .toString()

    if (selectedGroupGroupsLocations && selectedTab === 'groups') {
      dispatch(setLoading(true, 'fetchRolesCounts'))
      AxiosInstance.get(
        `/manager-reports/role-count/group/${
          selectedGroupGroupsLocations.id
        }?group_id=${selectedGroupsGroups.map(
          (item) => item.id
        )}&module_id=${locationGroupIds}&token=${accessToken()}`,
        { cancelToken: callForRoles.token }
      ).then((rolesCount) => {
        const rolesWithNumbers = []
        // let newRoles = roles.map((item, i) =>
        // 	Object.assign({}, item, rolesCount[i])
        // )

        rolesCount.map((item) => {
          item.name = item.name + ` (${item.count || 0})`
          rolesWithNumbers.push(item)
        })

        dispatch({ type: types.SET_ROLES, rolesCount: rolesWithNumbers })
        dispatch(setLoading(false, 'fetchRolesCounts'))
      })
    } else if (
      selectedTab === 'courses' ||
      selectedTab === 'external-reports'
    ) {
      dispatch(setLoading(true, 'fetchRolesCounts'))
      AxiosInstance.get(
        `/manager-reports/role-count?module_id=${
          selectedTab === 'courses'
            ? locationCourseIds
            : locationExternalReportsIds
        }&token=${accessToken()}`
      ).then((rolesCount) => {
        const rolesWithNumbers = []
        // let newRoles = roles.map((item, i) =>
        // 	Object.assign({}, item, rolesCount[i])
        // )
        rolesCount.map((item) => {
          item.name = item.name + ` (${item.count || 0})`
          rolesWithNumbers.push(item)
        })

        dispatch({ type: types.SET_ROLES, rolesCount: rolesWithNumbers })
        dispatch(setLoading(false, 'fetchRolesCounts'))
      })
    }
  }
}

export const fetchPublicCatalogForManagerReport = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_PUBLIC_CATALOG_LOADING, payload: true })

    const courseConfig = getState().courseConfig
    const { publicCatalogPercentage } = getState().generalConfig

    AxiosInstance.get('/manager-reports/public-catalog')
      .then((response) => {
        const data = response

        if (!data || !data.columnDefs || !data.rowData) {
          console.error('Invalid API response:', response)
          return
        }

        dispatch({ type: types.SET_PUBLIC_CATALOG_DATA_FETCHED, payload: true })

        const modifiedColumnDefs = data.columnDefs.map((colDef) => {
          if (colDef.field !== 'userName') {
            return {
              ...colDef,
              cellRenderer: (params) => {
                if (params.value !== undefined && params.value !== null) {
                  const icon = getFontawesomeIconFromStatus(
                    params.value,
                    courseConfig
                  )

                  const statusLabel = getLabelForPublicCatalog(
                    params.value,
                    params.data[`${colDef.field}_percentage`],
                    publicCatalogPercentage
                  )

                  return (
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      {icon}
                      <span
                        style={{
                          color: getStatusColorReport(
                            params.value,
                            null,
                            courseConfig
                          ),
                        }}
                      >
                        {statusLabel}
                      </span>
                    </span>
                  )
                }
                return <span>N/A</span>
              },
            }
          }

          if (colDef.field === 'userName') {
            return {
              ...colDef,
              cellRenderer: (params) => (
                <Link
                  style={{ color: 'rgb(136, 137, 170)', fontWeight: 500 }}
                  to={`/manager-reports/employee/${params.data.userId}`}
                >
                  {params.value}
                </Link>
              ),
            }
          }

          return colDef
        })

        dispatch({
          type: types.SET_PUBLIC_CATALOG_COLUMN_DEFS,
          payload: modifiedColumnDefs,
        })

        dispatch({
          type: types.SET_PUBLIC_CATALOG_ROW_DATA,
          payload: data.rowData,
        })

        dispatch({ type: types.SET_PUBLIC_CATALOG_LOADING, payload: false })
      })
      .catch((error) => {
        console.error('Error fetching data:', error)
        dispatch({ type: types.SET_PUBLIC_CATALOG_LOADING, payload: false })
      })
  }
}

// export const exportPublicCatalogToCsv = () => {
//   return (dispatch, getState) => {
//     const { publicCatalogRowData: rows, publicCatalogColumnDefs: columns } =
//       getState().managerReport

//     const { publicCatalogPercentage } = getState().generalConfig

//     const courseNames = columns
//       .map((c) => c.headerName)
//       .map(encodeURIComponent)
//       .slice(1)

//     const progressLabel = {
//       0: 'N/A',
//       1: 'In Progress',
//       2: 'Failed',
//       3: 'Needs Manager Approval',
//       4: 'Certified',
//       5: 'Validation',
//       6: 'Quiz Pending',
//     }

//     const [userName, ...courseIds] =
//       columns && columns.length && columns.map((c) => c.field)

//     const userData =
//       rows &&
//       rows.length &&
//       rows.map(({ userId, userName, email, country, ...others }) => [
//         userName,
//         email ? email : '-',
//         country ? country : '-',
//         ...courseIds.map((id) => {
//           let text = ``
//           const dates = others[id]
//             ? others[`${id}_dates`]
//               ? others[`${id}_dates`]
//               : '(| - |)'
//             : ''

//           if (others[id] !== undefined) {
//             if (!publicCatalogPercentage) {
//               text = progressLabel[others[id]]
//             } else {
//               if (others[id] === 1) {
//                 if (others[`${id}_percentage`]) {
//                   text = `${progressLabel[others[id]]} ${
//                     others[`${id}_percentage`]
//                   }%`
//                 } else {
//                   text = `${progressLabel[others[id]]} 0%`
//                 }
//               } else text = progressLabel[others[id]]
//             }
//           } else {
//             text = progressLabel[0]
//           }
//           return `${text} ${dates}`
//         }),
//       ])
//     window.open(
//       clientBaseUrl() +
//         `/public-catalog/report?courses=${courseNames}&data=${userData.map(
//           encodeURIComponent
//         )}&token=${accessToken()}`,
//       '_blank'
//     )
//   }
// }

export const exportPublicCatalogToCsv = () => {
  window.open(
    clientBaseUrl() + `/public-catalog/report?token=${accessToken()}`,
    '_blank'
  )
}

export const getPublicCatalogPercentages = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_PUBLIC_CATALOG_CHARTS_LOADING, payload: true })

    const { publicCatalogColumnDefs: courses } = getState().managerReport

    const courseIds = courses
      ?.slice(1)
      ?.map((c) => c?.field?.split('_')?.at(1))
      ?.join(',')

    AxiosInstance.get(
      `/public-catalog/percentages?courseIds=${courseIds}`
    ).then((data) => {
      dispatch({ type: types.SET_PUBLIC_CATALOG_CHARTS, payload: data })
      dispatch({
        type: types.SET_PUBLIC_CATALOG_CHARTS_LOADING,
        payload: false,
      })
    })
  }
}

export const onClickSearch = () => {
  return (dispatch, getState) => {
    const value = getState().managerReport.searchValue

    dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value })
  }
}
export const onResetSearch = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value: '' })
    dispatch({ type: types.SET_SEARCH_VALUE, value: '' })
  }
}

export const setBreadcrumb = (array) => {
  return (dispatch) => {
    dispatch({ type: types.SET_BREADCRUMB, payload: array })
  }
}

export const setBreadcrumbAll = (array) => {
  return (dispatch) => {
    dispatch({ type: types.SET_BREADCRUMB_ALL, payload: array })
  }
}

export const spliceBreadcrumb = (id) => {
  return (dispatch, getState) => {
    const breadcrumb = getState().managerReport.breadcrumb
    let newData = [...breadcrumb]

    if (!id) {
      newData = []
    } else if (breadcrumb.length > 1) {
      newData = breadcrumb.splice(
        0,
        breadcrumb.findIndex((breadcrumbItem) => breadcrumbItem.id == id) + 1
      )
    }

    dispatch({ type: types.SET_BREADCRUMB, payload: newData })
  }
}

export const addToBreadcrumb = (item) => {
  return (dispatch, getState) => {
    const breadcrumbAll = getState().managerReport.breadcrumbAll

    if (breadcrumbAll.find((breadcrumbItem) => breadcrumbItem.id == item.id)) {
      return
    }

    dispatch({ type: types.ADD_TO_BREADCRUMB_ALL, payload: item })
  }
}

export const addToBreadcrumbActive = (id) => {
  return (dispatch, getState) => {
    const breadcrumbAll = getState().managerReport.breadcrumbAll
    const breadcrumb = getState().managerReport.breadcrumb
    const current = breadcrumbAll.find(
      (breadcrumbItem) => breadcrumbItem.id == id
    )

    if (current) {
      if (
        breadcrumb.find((breadcrumbItem) => breadcrumbItem.id == current.id)
      ) {
        return
      }
      dispatch({ type: types.ADD_TO_BREADCRUMB, payload: current })
    }
  }
}

export const setManagerId = (id) => {
  return (dispatch) => {
    dispatch({ type: types.SET_MANAGER_ID, payload: id })
  }
}

export const setLoading = (isLoading, method) => {
  return (dispatch, getState) => {
    const { requestsLoading } = getState().managerReport
    const newData = { ...requestsLoading, [method]: isLoading }
    dispatch({ type: types.SET_LOADING, payload: newData })
  }
}
